<template>
  <div class="company-info">
    <h3>Contact Us</h3>
    <h4>Organism Card Questions</h4>
    <p><b>Suzan Luther</b></br>suzan@bcamsc.org</br>(269) 213-3904</p>
    <p>Once submitted, you will receive an email confirmation. Please save the email for future reference. If you did not receive the confirmation email, please check your spam folder or try resubmitting your order.</p>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>
